module.exports = __webpack_public_path__ + "static/media/om_hairstyle_wavy_front_vector.61990720.svg";